import { Component, computed, inject, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { MceApiService } from '../core/mceapi.client.generated';
import { LocalStorageService } from '../core/localStorageService';
import { PageWithNavigationComponent } from '../shared/page-templates/page-with-navigation/page-with-navigation.component';
import { EquipmentDataComponent } from './equipment-data/equipment-data.component';
import { MetalPricesComponent } from './metal-prices/metal-prices.component';
import { ProjectsStatusComponent } from './projects-status/projects-status.component';
import { StandardsReferenceComponent } from './standards-reference/standards-reference.component';
import { InfoMessageComponent } from '../shared/components/info-message/info-message.component';

@Component({
    selector: 'mce-dashboard',
  imports: [
    ProjectsStatusComponent, StandardsReferenceComponent, EquipmentDataComponent,
    MetalPricesComponent, InfoMessageComponent, PageWithNavigationComponent],
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {

  private readonly mceApiService = inject(MceApiService);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly dismissedMotdUid = signal(this.localStorageService.dismissedMotdUid());

  readonly motdResource = rxResource({
    stream: () => this.mceApiService.v1SiteSettingsMotd()
  });
  readonly motd = computed(() => this.motdResource?.value() ?? { uid: '', html: '', endDate: { value: '' } });

  dismissMotd(): void {
    const currentMotdUid = this.motd().uid;
    if (!currentMotdUid) {
      return;
    }

    this.localStorageService.setDismissedMotdUid(currentMotdUid);
    this.dismissedMotdUid.set(currentMotdUid);
  }

  protected readonly viewState = computed(() => {
    const motd = this.motd();
    const hasMotdUid = !!motd.uid;
    const isCurrentMotdDismissed = hasMotdUid && motd.uid === this.dismissedMotdUid();
    const endDate = motd.endDate?.value;

    return {
      motd: motd.html,
      showMotd: hasMotdUid
        && !isCurrentMotdDismissed
        && endDate !== undefined
        && new Date(endDate).getTime() >= Date.now(),
    }
  });


}
